<template>
  <div class="page-container">
    <Filter :params="params" @search="searchData" add @add="addNew"></Filter>
    <Table :tableData="tableDataList" :total="total" @update="updatePage">
      <el-table-column
        prop="date"
        :label="$t('service.software.releaseDate')"
        width="120px"
      />
      <el-table-column
        prop="productName"
        :label="$t('service.software.productType')"
        width="150px"
      />
      <el-table-column
        prop="version"
        :label="$t('service.software.versionNumber')"
        width="180px"
      />
      <el-table-column
        prop="platformName"
        :label="$t('service.software.platform')"
        width="120px"
      />
      <el-table-column
        prop="packageName"
        :label="$t('service.software.installationPackage')"
        width="250px"
      >
        <template #default="{ row }">
          <a download="software" :href="row.url">{{ row.packageName }}</a>
        </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        :label="$t('service.software.versionUpdateContent')"
      />
      <el-table-column prop="createBy" :label="$t('activity.list.creator')" />
      <el-table-column
        prop="createTime"
        :label="$t('activity.list.createTime')"
      />
      <el-table-column
        prop="updateBy"
        :label="$t('status.largescreenm.updater')"
      />
      <el-table-column
        prop="updateTime"
        :label="$t('collect.healthscorelist.updateTime')"
      />
      <el-table-column
        :label="$t('activity.list.operation')"
        fixed="right"
        width="100px"
      >
        <template #default="{ row }">
          <el-button type="text" size="mini" @click="editDetail(row)">{{
            $t('activity.list.edit')
          }}</el-button>
          <el-button
            type="text"
            style="color: #f56c6c"
            size="mini"
            @click="deleteDetail(row)"
            >{{ $t('activity.packetjoin.delete') }}</el-button
          >
        </template>
      </el-table-column>
    </Table>
    <el-dialog
      :title="title"
      top="5vh"
      v-model="dialogFormVisible"
      destroy-on-close
      :modal="true"
      :append-to-body="true"
    >
      <el-form
        ref="detailformRef"
        class="dialog-form"
        :model="detailform"
        :rules="detailformRules"
        label-width="180px"
      >
        <el-form-item :label="$t('service.software.releaseDate')" prop="date">
          <el-date-picker
            v-model="detailform.date"
            type="date"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            :placeholder="$t('service.software.releaseDate')"
            clearable
            :disabled-date="disabledDate"
          />
        </el-form-item>
        <el-form-item label="version" prop="version">
          <el-input
            v-model="detailform.version"
            placeholder="version"
            clearable
          />
        </el-form-item>
        <el-form-item
          :label="$t('service.software.productType')"
          prop="productId"
        >
          <el-select
            v-model="detailform.productId"
            :placeholder="$t('service.software.productType')"
            clearable
            @change="onSelectProduct"
          >
            <el-option
              v-for="item in productList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('service.software.platform')"
          prop="platformName"
          v-if="detailform.productId == 11"
        >
          <el-input
            :disabled="true"
            v-model="detailform.platformName"
            :placeholder="$t('service.software.platform')"
            clearable
          />
        </el-form-item>
        <el-form-item
          :label="$t('service.software.platform')"
          prop="platformId"
          v-if="detailform.productId !== 11"
        >
          <el-select
            v-model="detailform.platformId"
            :placeholder="$t('service.software.platform')"
            clearable
          >
            <template v-for="item in platformList" :key="item.name">
              <el-option
                v-show="
                  !(item.name == 'CAB 32&64' && detailform.productId != 11)
                "
                :label="item.name"
                :value="item.id"
              />
            </template>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('service.software.installationPackage')"
          prop="filePath"
        >
          <!-- <el-input v-model="detailform.multipartFile" placeholder="安装包" />
          <el-button @click="importFile" type="primary" size="mini" plain>导入Excel</el-button> -->
          <el-upload
            :file-list="imageList"
            action="#"
            :auto-upload="false"
            name="image"
            :on-change="onImageChange"
            :on-remove="onImageRemove"
            :on-preview="onImagePreview"
          >
            <el-button size="small" type="primary">{{
              $t('service.software.clickToUpload')
            }}</el-button>
          </el-upload>
          <!-- <input ref="inputFile" type="file" @change="uploadFile">
          <el-progress style="max-width: 500px;" :percentage="wsProgress"></el-progress> -->
        </el-form-item>
        <el-form-item
          :label="$t('service.software.versionUpdateContent')"
          prop="remark"
        >
          <el-input
            type="textarea"
            :autosize="{ minRows: 4 }"
            :placeholder="$t('service.software.versionUpdateContent')"
            v-model="detailform.remark"
            clearable
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button size="small" type="primary" @click="editSubmit">{{
          $t('activity.list.confirm')
        }}</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { request, GET } from '@/utils/request'
import { common } from '@/common/mixin'
import { reactive, toRefs, ref } from '@vue/reactivity'
import { ElMessage, ElMessageBox } from 'element-plus'
import Table from '@/components/table/index'
import Filter from '@/components/table/filter'
import { wsDomain } from '@/common/config'
import { ossUpload } from '@/utils/oss'
import { reqGetPackageList } from '@/api/robot'
import { useI18n } from 'vue-i18n'
import { downloadFile } from '../../utils/request'
export default {
  components: {
    Table,
    Filter
  },
  mixins: [common],
  setup () {
    const { t } = useI18n()
    const productTypeList = ref([])
    const state = reactive({
      query: {},
      page: 1,
      size: 10,
      total: 0,
      dialogFormVisible: false,
      tableDataList: [],
      detailformRef: null,
      detailform: {
        date: '',
        version: '',
        productName: '',
        platformName: '',
        platformId: null,
        filePath: '',
        fileName: '',
        fileSize: '',
        remark: '',
        productId: null
      },
      params: [
        {
          key: 'version',
          value: '',
          label: t('service.software.versionNumber')
        },
        {
          type: 'Select',
          key: 'productList',
          value: '',
          label: t('service.software.productType'),
          options: {
            data: productTypeList,
            label: 'name',
            value: 'id'
          },
          attrs: {
            multiple: true
          }
        },
        {
          key: 'platformName',
          value: '',
          label: t('service.software.platform')
        }
      ],
      productList: [],
      platformList: [],
      wsProgress: 0,
      inputFile: null,
      title: t('service.software.addSoftware'),
      imageList: []
    })
    const detailformRules = reactive({
      date: {
        required: true,
        message: t('service.software.selectReleaseDate'),
        trigger: 'change'
      },
      version: {
        required: true,
        message: t('service.software.enterVersionNumber'),
        trigger: 'blur'
      },
      productName: {
        required: true,
        message: t('service.software.selectProductType'),
        trigger: 'change'
      },
      productId: {
        required: true,
        message: t('service.software.selectProductType'),
        trigger: 'change'
      },
      platformName: {
        required: true,
        message: t('service.software.selectPlatform'),
        trigger: 'change'
      },
      platformId: {
        required: true,
        message: t('service.software.selectPlatform'),
        trigger: 'change'
      },
      filePath: {
        required: true,
        message: t('service.software.uploadInstallationPackage'),
        trigger: 'change'
      },
      remark: {
        required: true,
        message: t('service.software.enterVersionUpdateContent'),
        trigger: 'blur'
      }
    })
    var wsp = null
    const getData = async () => {
      console.log('query', state.query)
      try {
        const res = await request('getPackageList', {
          ...state.query,
          pageNum: state.page,
          pageSize: state.size
        })
        state.tableDataList.length = 0
        state.tableDataList = res.records
        state.total = res.total
      } catch (error) {
        console.error(error)
      }
    }
    const getDataMap = () => {
      try {
        GET('getVersionProductList').then(res => {
          state.productList = res || []
          productTypeList.value = res || []
        })
      } catch (error) {
        console.error(error)
      }
    }
    const searchData = async data => {
      state.query = data
      getData()
    }
    const updatePage = (page, size) => {
      state.page = page || 1
      state.size = size || 10
      getData()
    }
    const addNew = () => {
      for (let key of Object.keys(state.detailform)) {
        state.detailform[key] = ''
      }
      state.dialogFormVisible = true
      state.wsProgress = Math.round(0)
      state.title = t('service.software.addSoftware')
      state.imageList = []
      console.log(state.detailform)
    }
    const editDetail = async row => {
      try {
        for (let key of Object.keys(state.detailform)) {
          if (row[key]) {
            state.detailform[key] = row[key]
            state.detailform.filePath = row.url || ''
            state.detailform.fileName = row.packageName || ''
            state.detailform.fileSize = row.size || ''
            state.wsProgress = Math.round(100)
          } else {
            state.detailform[key] = ''
          }
        }
        state.detailform.id = row.id
        state.dialogFormVisible = true
        state.imageList = [{ name: row.packageName, url: row.url }]
        state.title = t('service.software.editSoftware')
        getPackageList(state.detailform.productId)
      } catch (error) {
        console.error(error)
      }
    }
    const deleteDetail = async row => {
      try {
        await ElMessageBox.confirm(t('activity.list.confirmDelete'), {
          confirmButtonText: t('activity.list.confirm1'),
          cancelButtonText: t('activity.list.cancel'),
          type: 'warning'
        })
        await request('deleteVersionPackage', {
          id: row.id
        })
        getData()
        ElMessage({
          showClose: true,
          type: 'success',
          message: t('activity.packetreceive.deleteSuccess')
        })
      } catch (error) {
        console.error(error)
      }
    }
    const editSubmit = async () => {
      console.log('onSubmit', state.detailform)
      try {
        // const formData = new FormData();
        // Object.keys(state.detailform).forEach((key) => {
        //   formData.append(key, state.detailform[key])
        // })
        state.detailformRef && (await state.detailformRef.validate())
        state.title == t('service.software.addSoftware')
          ? await request('addVersionPackage', state.detailform)
          : await request('updateVersionPackage', state.detailform)
        // state.wsProgress=0
        // state.inputFile.value = ''
        state.dialogFormVisible = false
        getData()
        ElMessage({
          showClose: true,
          type: 'success',
          message: t('activity.list.submitSuccess')
        })
      } catch (error) {
        console.error(error)
      }
    }
    const onImageChange = async file => {
      state.imageList = [file]
      try {
        if (!file.raw) return
        const fileUrl = await ossUpload(file.raw.name, file.raw, {
          path: 'ota/software',
          timestamp: false,
          progress: p => {
            state.wsProgress = Math.round(p * 100)
          }
        })
        state.detailform.filePath = fileUrl || ''
        state.detailform.fileName = file.raw.name || ''
        state.detailform.fileSize = file.raw.size || ''
      } catch (error) {
        state.inputFile.value = ''
        console.error(error)
      }
    }
    const onImageRemove = () => {
      state.detailform.image = undefined
    }
    const onImagePreview = item => {
      console.log('onImagePreview', item)
      if (item) {
        state.viewerList = state.imageList.map(item => item.url)
        state.viewerIndex = state.viewerList.indexOf(item.url)
      }
    }

    const uploadFile = async e => {
      try {
        const file = e.target.files[0]
        if (!file) return
        const fileUrl = await ossUpload(file.name, file, {
          path: 'ota/software',
          timestamp: false,
          progress: p => {
            state.wsProgress = Math.round(p * 100)
          }
        })
        console.log('uploadFile', fileUrl)
        state.detailform.filePath = fileUrl || ''
        state.detailform.fileName = file.name || ''
        state.detailform.fileSize = file.size || ''
      } catch (error) {
        state.inputFile.value = ''
        console.error(error)
      }
    }
    const webProgress = () => {
      const url = wsDomain[process.env.NODE_ENV] + '/admin/uploadProgress'
      wsp = new WebSocket(url)
      wsp.onopen = function (evt) {
        console.log('Connection open ...', evt)
        // ws.send("Hello WebSockets!");
      }

      wsp.onmessage = function (evt) {
        state.wsProgress = Number(evt.data || 0)
        console.log('Received Message: ' + evt.data)
        // wsp.close();
      }

      wsp.onclose = function (evt) {
        console.log('Connection closed.', evt)
      }
    }
    const disabledDate = time => {
      return time.getTime() > Date.now()
    }
    const getPackageList = async value => {
      try {
        const res = await reqGetPackageList(value)
        state.platformList = res || []
      } catch (error) {
        console.error(error)
      }
    }
    const onSelectProduct = async value => {
      getPackageList(value)
      if (value == 11) {
        state.detailform.platformName = 'CAB 32&64'
        state.detailform.platformId = 12
      } else {
        state.detailform.platformName = ''
        state.detailform.platformId = null
      }
    }

    const downloadFile1 = async row => {
      console.log('packageName', row)
      let a = document.createElement('a')
      a.setAttribute('href', row.url)
      a.setAttribute('download', row.packageName)
      a.setAttribute('target', '_blank')
      let clickEvent = document.createEvent('MouseEvents')
      clickEvent.initEvent('click', true, true)
      a.dispatchEvent(clickEvent)
    }

    const downloadFile = async row => {
      try {
        // 1. 请求 OSS 文件，带上 mode: 'cors'
        const response = await fetch(row.url, {
          method: 'GET',
          mode: 'cors' // 关键：明确允许跨域
        })

        if (!response.ok) {
          throw new Error(`下载失败: ${response.status}`)
        }

        // 2. 获取二进制数据
        const blob = await response.blob()

        // 3. 创建 Blob URL
        const blobUrl = window.URL.createObjectURL(blob)

        // 4. 创建下载链接
        const a = document.createElement('a')
        a.href = blobUrl
        a.download = row.packageName // ✅ 这里会生效
        document.body.appendChild(a)
        a.click()

        // 5. 清理
        document.body.removeChild(a)
        window.URL.revokeObjectURL(blobUrl)
      } catch (error) {
        console.error('下载失败:', error)
        // 可以弹个提示给用户
      }
    }

    getData()
    getDataMap()
    return {
      ...toRefs(state),
      detailformRules,
      getData,
      searchData,
      updatePage,
      addNew,
      editDetail,
      deleteDetail,
      editSubmit,
      uploadFile,
      onImageChange,
      onImageRemove,
      onImagePreview,
      webProgress,
      disabledDate,
      onSelectProduct,
      downloadFile
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
</style>
